import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../dashboard/sidebar";
import Navbar from "../../dashboard/navbar";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import useAuth from "../../dashboard/useAuth";
import { FaChevronRight, FaSortAmountUp, FaSortAmountDown, FaChartLine, FaFileDownload, FaBook, FaFolderOpen, FaCheck, FaCheckCircle, FaRedo, FaFlagCheckered, FaTasks, FaQuestionCircle, FaInfoCircle, FaStar } from "react-icons/fa";
import { Dropdown } from 'react-bootstrap';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarController,   // ← ajouté
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarController,   // ← ajouté
  BarElement,
  Title,
  Tooltip,
  Legend
);


// ✅ Composant cartes de statistiques (style Inspinia)
const ParcoursStatsCards = ({ etapes }) => {
  const getParcoursStatsLocal = (etapes) => {
    if (!etapes || etapes.length === 0) {
      return { reussite: 0, completion: 0, etapesPct: 0, qcmsCorrectes: 0, qcmsTraitees: 0, qcmsGlobales: 0, etapesTerminees: 0, etapesTotales: 0 };
    }

    let qcmsCorrectes = 0;
    let qcmsTraitees = 0;
    let qcmsGlobales = 0;
    let etapesTerminees = 0;

    etapes.forEach((etape) => {
      if (etape.nombre_qcm && Number(etape.nombre_qcm) > 0) {
        qcmsGlobales += Number(etape.nombre_qcm);
      }
      if (etape.questions_traitees && Number(etape.questions_traitees) > 0) {
        qcmsTraitees += Number(etape.questions_traitees);
      }
      if (etape.score && typeof etape.score === 'string' && etape.score.includes('/')) {
        const [correctes] = etape.score.split('/');
        const correctesNum = parseInt(correctes.trim(), 10);
        if (!isNaN(correctesNum)) {
          qcmsCorrectes += correctesNum;
        }
      }
      if (etape.statut_etape === "Terminée") {
        etapesTerminees++;
      }
    });

    return {
      reussite: qcmsTraitees > 0 ? Math.round((qcmsCorrectes / qcmsTraitees) * 100) : 0,
      completion: qcmsGlobales > 0 ? Math.round((qcmsTraitees / qcmsGlobales) * 100) : 0,
      etapesPct: etapes.length > 0 ? Math.round((etapesTerminees / etapes.length) * 100) : 0,
      qcmsCorrectes,
      qcmsTraitees,
      qcmsGlobales,
      etapesTerminees,
      etapesTotales: etapes.length,
    };
  };

  const stats = getParcoursStatsLocal(etapes);

  return (
    <>
      <style>{`
        .stats-cards-row {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          justify-content: flex-end;
        }
        .stat-card {
          background: #ffffff;
          border-radius: 6px;
          padding: 12px 14px;
          min-width: 130px;
          flex: 0 0 auto;
          border: 1px solid #e7eaec;
          box-shadow: 0 1px 3px rgba(0,0,0,0.04);
          transition: all 0.3s ease;
        }
        .stat-card:hover {
          box-shadow: 0 3px 8px rgba(0,0,0,0.08);
          transform: translateY(-1px);
        }
        .stat-card-header {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          color: #676a6c;
          letter-spacing: 0.3px;
          margin-bottom: 4px;
        }
        .stat-card-header i {
          font-size: 13px;
        }
        .stat-card-header-green { color: #1ab394; }
        .stat-card-header-blue  { color: #1c84c6; }
        .stat-card-header-orange{ color: #f8ac59; }

        .stat-card-value {
          font-size: 22px;
          font-weight: 700;
          color: #2C3E50;
          line-height: 1.1;
          margin-bottom: 6px;
        }
        .stat-card-value small {
          font-size: 11px;
          font-weight: 400;
          color: #9b9b9b;
          margin-left: 4px;
        }
        .stat-card-progress {
          height: 5px;
          background-color: #e7eaec;
          border-radius: 3px;
          overflow: hidden;
        }
        .stat-card-progress-fill {
          height: 100%;
          border-radius: 3px;
          transition: width 0.6s ease;
        }
        .stat-card-progress-fill.green  { background-color: #1ab394; }
        .stat-card-progress-fill.blue   { background-color: #1c84c6; }
        .stat-card-progress-fill.orange { background-color: #f8ac59; }

        @media (max-width: 768px) {
          .stats-cards-row { justify-content: flex-start; }
          .stat-card { min-width: 100px; padding: 10px 12px; }
          .stat-card-value { font-size: 18px; }
        }
      `}</style>

      <div className="stats-cards-row">
        {/* Taux de réussite */}
        <div className="stat-card" title="QCM correctes / QCM traitées">
          <div className="stat-card-header stat-card-header-green">
            <FaCheckCircle />
            Réussite
          </div>
          <div className="stat-card-value">
            {stats.reussite}%
            <small>({stats.qcmsCorrectes} correctes / {stats.qcmsTraitees} traitées ) QCM</small>
          </div>
          <div className="stat-card-progress">
            <div
              className="stat-card-progress-fill green"
              style={{ width: `${stats.reussite}%` }}
            />
          </div>
        </div>

        {/* Complétion QCM */}
        <div className="stat-card" title="QCM traitées / QCM globales">
          <div className="stat-card-header stat-card-header-blue">
            <FaTasks />
            Complétion
          </div>
          <div className="stat-card-value">
            {stats.completion}%
            <small>({stats.qcmsTraitees} traitées / {stats.qcmsGlobales} globales ) QCM</small>
          </div>
          <div className="stat-card-progress">
            <div
              className="stat-card-progress-fill blue"
              style={{ width: `${stats.completion}%` }}
            />
          </div>
        </div>

        {/* Étapes terminées */}
        <div className="stat-card" title="Étapes terminées / Étapes totales">
          <div className="stat-card-header stat-card-header-orange">
            <FaFlagCheckered />
            Étapes
          </div>
          <div className="stat-card-value">
            {stats.etapesPct}%
            <small>({stats.etapesTerminees} terminées / {stats.etapesTotales} totales )</small>
          </div>
          <div className="stat-card-progress">
            <div
              className="stat-card-progress-fill orange"
              style={{ width: `${stats.etapesPct}%` }}
            />
          </div>
        </div>
      </div>
    </>
  );
};


// ─────────────────────────────────────────────────────────────
// ✅ Histogramme : évolution des QCM traités / semaine
//    Source : evaluation.json de l'utilisateur (date réelle de réalisation)
// ─────────────────────────────────────────────────────────────

const pad2 = (n) => String(n).padStart(2, '0');

// "08-07-2026 14:32:10" (ou "2026-07-08 ...", ou "08/07/2026") -> Date locale
const parseEvalDate = (str) => {
  if (!str || typeof str !== 'string') return null;
  const [datePart] = str.trim().split(' ');
  const parts = datePart.split(/[-/]/).map(Number);
  if (parts.length !== 3 || parts.some((p) => isNaN(p))) return null;
  const [a, b, c] = parts;
  const [day, month, year] = a > 31 ? [c, b, a] : [a, b, c]; // gère aussi YYYY-MM-DD
  const date = new Date(year, month - 1, day);
  return isNaN(date.getTime()) ? null : date;
};

// Lundi (00:00, heure locale) de la semaine d'une date
const getMonday = (date) => {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const day = d.getDay() || 7; // dimanche = 7
  d.setDate(d.getDate() - (day - 1));
  return d;
};

const mondayKey = (monday) =>
  `${monday.getFullYear()}-${pad2(monday.getMonth() + 1)}-${pad2(monday.getDate())}`;

// Numéro de semaine ISO
const getIsoWeek = (date) => {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
};

// Normalise les tags ("A, B" | ["A", "B"] | "A") en tableau de tags minuscules
const splitTags = (tags) => {
  if (Array.isArray(tags)) return tags.flatMap(splitTags);
  if (typeof tags === 'string') {
    return tags.split(',').map((t) => t.trim().toLowerCase()).filter(Boolean);
  }
  return [];
};

const getWeeklyData = (etapes, evaluations, globalView) => {
  const empty = { labels: [], values: [], nbEvals: [], correctes: [], hasCorrectes: false };

  // 1️⃣ Sélection des évaluations concernées
  let relevantEvals = (evaluations || []).filter(
    (ev) => ev && Number(ev.questions_traitees) > 0
  );

  if (!globalView) {
    // Tags des étapes "Evaluation" du parcours affiché
    const parcoursTags = new Set();
    (etapes || []).forEach((etape) => {
      if (etape.module === 'Evaluation') {
        splitTags(etape.tags).forEach((t) => parcoursTags.add(t));
      }
    });
    if (parcoursTags.size === 0) return empty;

    relevantEvals = relevantEvals.filter((ev) =>
      splitTags(ev.tags).some((t) => parcoursTags.has(t))
    );
  }

  // 2️⃣ Regroupement par semaine (clé = lundi de la semaine)
  const weeks = {};
  relevantEvals.forEach((ev) => {
    const date = parseEvalDate(ev.date);
    if (!date) return;
    const monday = getMonday(date);
    const key = mondayKey(monday);
    if (!weeks[key]) weeks[key] = { monday, traitees: 0, correctes: 0, nb: 0 };
    weeks[key].traitees += Number(ev.questions_traitees) || 0;
    weeks[key].correctes += Number(ev.nombre_correct) || 0;
    weeks[key].nb += 1;
  });

  const keys = Object.keys(weeks).sort();
  if (keys.length === 0) return empty;

  // 3️⃣ Remplir les semaines sans activité pour garder une échelle de temps continue
  const labels = [];
  const values = [];
  const nbEvals = [];
  const correctes = [];
  // const last = weeks[keys[keys.length - 1]].monday;

  // ✅ Étendre jusqu'à la semaine actuelle (aujourd'hui)
  const today = new Date();
  const last = getMonday(today);

  for (let cur = new Date(weeks[keys[0]].monday); cur <= last; cur.setDate(cur.getDate() + 7)) {
    const w = weeks[mondayKey(cur)];
    labels.push(`S${pad2(getIsoWeek(cur))} · ${pad2(cur.getDate())}/${pad2(cur.getMonth() + 1)}`);
    values.push(w ? w.traitees : 0);
    nbEvals.push(w ? w.nb : 0);
    correctes.push(w ? w.correctes : 0);
  }

  const hasCorrectes = relevantEvals.some((ev) => ev.nombre_correct !== undefined && ev.nombre_correct !== null);

  return { labels, values, nbEvals, correctes, hasCorrectes };
};

const ParcoursEvolutionChart = ({ etapes, evaluations, globalView }) => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  const { labels, values, nbEvals, correctes, hasCorrectes } = getWeeklyData(etapes, evaluations, globalView);

  // Clé stable : évite de recréer le graphique à chaque rendu du parent
  const dataKey = JSON.stringify({ labels, values, nbEvals, correctes });

  useEffect(() => {
    if (!canvasRef.current || labels.length === 0) return;

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    chartRef.current = new ChartJS(canvasRef.current.getContext('2d'), {
      type: 'bar',
      data: {
        labels,
        datasets: [
          {
            label: 'QCM traités',
            data: values,
            backgroundColor: '#1ab394',
            borderRadius: 4,
            maxBarThickness: 50,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              title: (items) => `Semaine ${items[0].label}`,
              label: (item) => `${item.raw} QCM traités`,
              afterLabel: (item) => {
                const i = item.dataIndex;
                const lines = [`${nbEvals[i]} évaluation(s)`];
                if (hasCorrectes && values[i] > 0) {
                  lines.push(`Réussite : ${Math.round((correctes[i] / values[i]) * 100)}%`);
                }
                return lines;
              },
            },
          },
        },
        scales: {
          x: {
            grid: { display: false },
            title: {
              display: true,
              text: 'Semaine (n° ISO · lundi)',
              color: '#676a6c',
              font: { size: 11 },
            },
            ticks: { color: '#676a6c' },
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Nombre de QCM traités',
              color: '#676a6c',
              font: { size: 11 },
            },
            ticks: { color: '#676a6c', precision: 0 },
            grid: { color: '#e7eaec' },
          },
        },
      },
    });

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataKey]);

  if (labels.length === 0) {
    return (
      <div className="text-center p-4 text-muted">
        <i className="fa fa-bar-chart fa-3x mb-3" style={{ color: '#c2c2c2' }}></i>
        <p className="mb-0">Aucun QCM traité à afficher pour le moment.</p>
        <small>Lancez une évaluation pour voir votre évolution semaine après semaine.</small>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative', height: '320px' }}>
      <canvas ref={canvasRef}></canvas>
    </div>
  );
};


const Parcours = () => {
  useAuth(); // Vérifier l'authentification
  const location = useLocation();
  const navigate = useNavigate();
  const { user, titre } = location.state || {};
  const user_id = localStorage.getItem("user_id");
  const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
  const [parcours, setParcours] = useState([]);
  const [ressource, setRessource] = useState();
  const [progress, setProgress] = useState(0);
  const [openSemaine, setOpenSemaine] = useState({}); // État pour gérer les semaines ouvertes/fermées
  const [alert, setAlert] = useState({ message: '', type: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGlobale, setIsLoadingGlobale] = useState(false);
  const [evaluations, setEvaluations] = useState([]); // ✅ Évaluations (evaluation.json)
  const [globalView, setGlobalView] = useState(false); // ✅ Histogramme : tous parcours confondus

  const [evaluation, setEvaluation] = useState({
    domaine: '',
    processus: '',
    niveau: '',
    tags: '',
    agile: false,
    nonTraite: false,
  });

  const [parcoursListe, setParcoursListe] = useState([]);
  const fetchParcoursListe = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_HOTE + '/liste-parcours/');
      const data = await response.json();
      if (response.ok) {
        setParcoursListe(data.parcours);
      } else {
        console.error('Erreur lors de la récupération des parcours : ', data);
      }
    } catch (error) {
      console.error('Erreur réseau:', error);
    }
  };
  useEffect(() => {
    fetchParcoursListe();
  }, []);



  const fetchParcours = async () => {
    setIsLoadingGlobale(true)
    try {
      const response = await fetch(
        process.env.REACT_APP_HOTE + `/recuperer-etapes-par-utilisateur/${user_id}/`
      );
      if (response.ok) {
        const data = await response.json();
        const etapes = Object.values(data.fichiers_data).flatMap(
          (file) => file.etapes || []
        );
        setParcours(etapes);
        const ressource = Object.values(data.fichiers_data).flatMap(
          (file) => file.ressource || []
        );
        setRessource(ressource)

        // Calcul de la progression
        const termineCount = etapes.filter(
          (etape) => etape.statut_etape === "Terminée"
        ).length;
        const totalCount = etapes.length;
        setProgress(totalCount > 0 ? Math.round((termineCount / totalCount) * 100) : 0);
        setIsLoadingGlobale(false)
      } else {
        const errorData = await response.json();
        console.error("Erreur lors de la récupération des parcours:", errorData);
        setIsLoadingGlobale(false)
      }
    } catch (error) {
      console.error("Erreur réseau:", error);
      setIsLoadingGlobale(false)
    }
  };

  // ✅ Récupérer le contenu de evaluation.json de l'utilisateur
  const fetchEvaluations = async () => {
    if (!user_id) return;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/liste-evaluations/${user_id}/`
      );
      if (response.ok) {
        const data = await response.json();
        const raw = data.evaluations ?? data;
        setEvaluations(Array.isArray(raw) ? raw : Object.values(raw || {}));
      } else {
        console.error("Erreur lors de la récupération des évaluations");
      }
    } catch (error) {
      console.error("Erreur réseau (évaluations):", error);
    }
  };

  useEffect(() => {
    fetchEvaluations();
  }, [user_id]);

  const handleDownloadRessource = (parcour_id) => {

    // Construire l'URL pour le téléchargement
    const downloadUrl = `${process.env.REACT_APP_HOTE}/telecharger-ressource/${parcour_id}/${user_id}/`;
    //window.location.href = downloadUrl;

    // Utiliser `fetch` pour vérifier si l'URL est valide
    fetch(downloadUrl, {
      method: "GET",
    })
      .then((response) => {
        if (response.ok) {
          // Si le fichier existe, redirige l'utilisateur pour lancer le téléchargement
          window.location.href = downloadUrl;
          showAlert("Téléchargement éffectué.");
        } else {
          showAlert("Le fichier est introuvable ou le téléchargement a échoué.");
        }
      })
      .catch((error) => {
        console.error("Erreur lors du téléchargement :", error);
        showAlert("Une erreur s'est produite lors du téléchargement.");
      });
  };



  // useEffect(() => {
  //   // Vérifier si c'est la première visite
  //   const hasVisited = localStorage.getItem("hasVisitedDashboard");
  //   if (!hasVisited) {
  //     localStorage.setItem("hasVisitedDashboard", "true");
  //     window.location.reload();
  //   }
  // }, [user_id]);

  const showAlert = (message, type = 'success') => {
    setAlert({ message, type });
    setTimeout(() => {
      setAlert({ message: '', type: '' });
    }, 5000);
  };

  useEffect(() => {
    fetchParcours();
  }, [user_id]);

  useEffect(() => {
    if (user_id) {
      document.title = "eTrainApp | Parcours d'apprentissage"; // Définit le titre de la page
    }
  }, [user_id]);

  const groupByParcoursId = (parcours) => {
    return parcours.reduce((acc, etape) => {
      const parcoursId = etape.parcours_id || 'Parcours inconnu'; // Utilisez un nom par défaut pour les étapes sans `parcours_id`
      if (!acc[parcoursId]) {
        acc[parcoursId] = [];
      }
      acc[parcoursId].push(etape);
      return acc;
    }, {});
  };

  const groupedParcours = groupByParcoursId(parcours);


  // Fonction pour générer les données du graphique pour un parcours donné
  const getParcoursChartData = (parcours) => {
    if (!parcours || parcours.length === 0) return null;

    return {
      labels: parcours.map((_, index) => `Étape ${index + 1}`), // Génère Étape 1, Étape 2, etc.
      datasets: [
        {
          label: "Progression des étapes",
          data: parcours.map((etape) =>
            etape.statut_etape === "Terminée" ? 100 : 0
          ), // 100% si terminé, sinon 0%
          backgroundColor: parcours.map((etape) =>
            etape.statut_etape === "Terminée" ? "rgba(75, 192, 192, 0.6)" : "rgba(255, 99, 132, 0.6)"
          ),
          borderWidth: 1,
        },
      ],
    };
  };

  // Options du graphique
  const chartOptions = {
    responsive: true,
    scales: {
      x: {
        title: {
          display: true,
          text: "Étapes",
        },
      },
      y: {
        beginAtZero: true,
        max: 100,
        title: {
          display: true,
          text: "Progression (%)",
        },
      },
    },
  };

  // Fonction pour récupérer le dernier parcours
  const getLastParcours = (groupedParcours) => {
    const lastParcoursId = Object.keys(groupedParcours).pop();
    return groupedParcours[lastParcoursId] || [];
  };

  // ✅ Calcule les statistiques globales d'un parcours
  const getParcoursStats = (etapes) => {
    if (!etapes || etapes.length === 0) {
      return { reussite: 0, completion: 0, etapesPct: 0, qcmsCorrectes: 0, qcmsTraitees: 0, qcmsGlobales: 0, etapesTerminees: 0, etapesTotales: 0 };
    }

    let qcmsCorrectes = 0;
    let qcmsTraitees = 0;
    let qcmsGlobales = 0;
    let etapesTerminees = 0;

    etapes.forEach((etape) => {
      // Nombre de QCM globales pour cette étape (uniquement si module = Evaluation ou Revision)
      if (etape.nombre_qcm && Number(etape.nombre_qcm) > 0) {
        qcmsGlobales += Number(etape.nombre_qcm);
      }

      // Questions traitées
      if (etape.questions_traitees && Number(etape.questions_traitees) > 0) {
        qcmsTraitees += Number(etape.questions_traitees);
      }

      // Questions correctes : extraire depuis le champ "score" au format "X/Y"
      if (etape.score && typeof etape.score === 'string' && etape.score.includes('/')) {
        const [correctes] = etape.score.split('/');
        const correctesNum = parseInt(correctes.trim(), 10);
        if (!isNaN(correctesNum)) {
          qcmsCorrectes += correctesNum;
        }
      }

      // Étapes terminées
      if (etape.statut_etape === "Terminée") {
        etapesTerminees++;
      }
    });

    return {
      reussite: qcmsTraitees > 0 ? Math.round((qcmsCorrectes / qcmsTraitees) * 100) : 0,
      completion: qcmsGlobales > 0 ? Math.round((qcmsTraitees / qcmsGlobales) * 100) : 0,
      etapesPct: etapes.length > 0 ? Math.round((etapesTerminees / etapes.length) * 100) : 0,
      qcmsCorrectes,
      qcmsTraitees,
      qcmsGlobales,
      etapesTerminees,
      etapesTotales: etapes.length,
    };
  };

  // Fonction pour vérifier si l'étape précédente est terminée
  const isPreviousStepCompleted = (etape, parcoursData) => {
    if (!etape.etapePrec || etape.etapePrec === 0) {
      return true;
    }

    // Trouver l'étape précédente dans toutes les étapes du parcours
    const previousEtape = parcoursData.find(e => e.id === etape.etapePrec);

    // Si l'étape précédente existe et est terminée
    return previousEtape && previousEtape.statut_etape === "Terminée";
  };


  const handleEtapeClick = async (etape) => {
    const etapeId = etape.id;
    const module = etape.module;
    setIsLoading(true);

    try {
      const excludedModules = ["Revision", "Evaluation", "Eligibilite"];

      if (excludedModules.includes(module)) {
        if (module === "Revision") {
          // Appel pour terminer l'étape
          const terminerEtapeResponse = await fetch(
            `${process.env.REACT_APP_HOTE}/terminer-etape-utilisateur/${user_id}/${etapeId}/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (!terminerEtapeResponse.ok) {
            // throw new Error("Erreur lors de la tentative de terminer l'étape");
            const data = await terminerEtapeResponse.json();
            setIsLoading(false);
          }

          const terminerData = await terminerEtapeResponse.json();
          setIsLoading(false);
          fetchParcours();

        } else if (module === "Eligibilite") {
          const terminerEtapeResponse = await fetch(
            `${process.env.REACT_APP_HOTE}/terminer-etape-utilisateur/${user_id}/${etapeId}/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (!terminerEtapeResponse.ok) {
            // throw new Error("Erreur lors de la tentative de terminer l'étape");
            const data = await terminerEtapeResponse.json();
            setIsLoading(false);
          }

          const terminerData = await terminerEtapeResponse.json();
          setIsLoading(false);
          fetchParcours();
          navigate(`/eligibilite`);

        } else if (module === "Etude_de_cas") {
          const terminerEtapeResponse = await fetch(
            `${process.env.REACT_APP_HOTE}/terminer-etape-utilisateur/${user_id}/${etapeId}/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (!terminerEtapeResponse.ok) {
            // throw new Error("Erreur lors de la tentative de terminer l'étape");
            const data = await terminerEtapeResponse.json();
            setIsLoading(false);
          }

          const terminerData = await terminerEtapeResponse.json();
          setIsLoading(false);
          fetchParcours();
          navigate(`/Etude-de-cas`);

        } else {
          try {
            const evaluationData = {
              ...evaluation,
              tags: `${evaluation.tags ? evaluation.tags + ", " : ""}${etape.tags}`,
              nombre_qcm: etape.nombre_qcm,
            };

            const response = await fetch(
              `${process.env.REACT_APP_HOTE}/enreg-evaluation/${user_id}/`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(evaluationData),
              }
            );
            const data = await response.json();

            if (!response.ok) {
              console.log("Erreur lors de l'enregistrement de l'évaluation", data);
              setIsLoading(false);
            }

            console.log("Réponse du serveur (évaluation enregistrée) :", data);

            // Démarrer l'évaluation
            const demarrerResponse = await fetch(
              `${process.env.REACT_APP_HOTE}/demarrer-evaluation/${user_id}/${data.evaluation_id}/`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
              }
            );

            const demarrerData = await demarrerResponse.json();
            console.log("Réponse du serveur (démarrer évaluation) :", demarrerData);

            if (!demarrerResponse.ok) {
              showAlert(demarrerData.error, 'danger');
            } else {
              // ✅ Générer un timestamp unique pour cette session
              const sessionTs = `${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;

              navigate(`/demarrer-qcm`, {
                state: {
                  evaluation_id: data.evaluation_id,
                  etape_id: etapeId,
                  tag: etape.tags,
                  _ts: sessionTs,          // ✅ nouveau
                },
              });
            }
          } catch (error) {
            console.error("Erreur:", error);
          } finally {
            setIsLoading(false);
          }
        }
      } else {
        console.log(`Aucune action requise pour le module : ${module}`);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Erreur:", error);
      showAlert("Une erreur est survenue lors de la tentative de terminer l'étape !");
      setIsLoading(false);
    }
  };

  const handleDownload = (etapeId) => {
    if (!etapeId) {
      showAlert("Aucun fichier à télécharger.");
      return;
    }

    // Construire l'URL pour le téléchargement
    const downloadUrl = `${process.env.REACT_APP_HOTE}/telecharger_fichier/${etapeId}/${user_id}/`;
    //window.location.href = downloadUrl;

    // Utiliser `fetch` pour vérifier si l'URL est valide
    fetch(downloadUrl, {
      method: "GET",
    })
      .then((response) => {
        if (response.ok) {
          // Si le fichier existe, redirige l'utilisateur pour lancer le téléchargement
          window.location.href = downloadUrl;
        } else {
          showAlert("Le fichier est introuvable ou le téléchargement a échoué.");
        }
      })
      .catch((error) => {
        console.error("Erreur lors du téléchargement :", error);
        showAlert("Une erreur s'est produite lors du téléchargement.");
      });
  };



  const handleHistorique = (etape_id, parcours_id) => {
    if (etape_id) {
      navigate(`/Historique-evaluation`, {
        state: { etape_id: etape_id, parcours_id: parcours_id },
      });
    }
  };


  const [etapeStatuses, setEtapeStatuses] = useState([]);
  const [etapes, setEtapes] = useState([]);

  useEffect(() => {
    // Vérifie le statut et l'échéance de chaque étape
    const updatedStatuses = etapes.map((etape) => {
      const isLate =
        etape.statut_etape !== "Terminée" &&
        new Date(etape.date_echeance) < new Date();

      return {
        ...etape,
        isLate,
      };
    });
    setEtapeStatuses(updatedStatuses);
  }, [etapes]);








  const [openParcoursId, setOpenParcoursId] = useState(() => {
    const saved = localStorage.getItem("openParcoursId");
    return saved || null;  // ✅ on garde la string telle quelle
  });

  // const handleToggle = (selectedParcours) => {
  //   const newValue = openParcoursId === selectedParcours ? null : selectedParcours;
  //   setOpenParcoursId(newValue);
  //   if (newValue) {
  //     localStorage.setItem("openParcoursId", newValue);
  //   } else {
  //     localStorage.removeItem("openParcoursId");
  //   }
  // };

  const handleToggle = (selectedParcours) => {
  // ✅ Si on clique sur le parcours déjà ouvert, ne rien faire
  if (openParcoursId === selectedParcours) {
    return;
  }
  
  setOpenParcoursId(selectedParcours);
  localStorage.setItem("openParcoursId", selectedParcours);
};

  // ✅ À AJOUTER JUSTE APRÈS handleToggle
  useEffect(() => {
    if (Object.keys(groupedParcours).length === 0) return;

    const isValid = openParcoursId && groupedParcours[openParcoursId];
    if (!isValid) {
      const firstId = Object.keys(groupedParcours).sort((a, b) => b - a)[0];
      setOpenParcoursId(firstId);
      localStorage.setItem("openParcoursId", firstId);
    }
  }, [groupedParcours, openParcoursId]);



  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 2;  // Nombre d'éléments par page

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  // Filtrer les données selon la recherche
  const filteredData = (parcoursId) => {
    const currentData = groupedParcours[parcoursId];
    return currentData.filter((etape) => {
      return (
        etape.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        etape.module.toLowerCase().includes(searchTerm.toLowerCase()) ||
        etape.date_echeance.toLowerCase().includes(searchTerm.toLowerCase()) ||
        etape.numero.toString().includes(searchTerm.toLowerCase()) ||
        etape.score.toString().includes(searchTerm.toLowerCase()) ||
        etape.statut_etape.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
  };

  // Calculer les indices de début et de fin de la page actuelle
  const getCurrentPageData = (parcoursId) => {
    const filteredPageData = filteredData(parcoursId);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredPageData.slice(startIndex, endIndex);
  };

  // Changer de page
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getTextColor = (bgColor) => {
    if (!bgColor || bgColor === 'transparent') return 'inherit'; // Couleur par défaut

    // Convertit la couleur hex en RGB
    const hexToRgb = (hex) => {
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
      ] : [0, 0, 0];
    };

    const [r, g, b] = hexToRgb(bgColor);

    // Calcule la luminance (formule de perception humaine)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Retourne noir ou blanc selon la luminance
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
  };



  const getModuleIcon = (module) => {
    switch (module) {
      case 'Cours':
        return <FaBook className="mr-2" />;
      case 'Ressources':
        return <FaFolderOpen className="mr-2" />;
      case 'Evaluation':
        return <FaQuestionCircle className="mr-2" />;
      case 'Revision':
        return <FaRedo className="mr-2" />;
      case 'Eligibilite':
        return <FaFlagCheckered className="mr-2" />;
      case 'Avis_client':
        return <FaStar className="mr-2" />;
      default:
        return <FaTasks className="mr-2" />;
    }
  };


  const getModuleName = (module) => {
    switch (module) {
      case 'Cours':
        return "Cours";
      case 'Ressources':
        return "Ressources";
      case 'Evaluation':
        return "Evaluation";
      case 'Revision':
        return "Revision";
      case 'Eligibilite':
        return "Eligibilite";
      case 'Avis_client':
        return "Avis client";
      case 'Etude_de_cas':
        return "Etude de cas";
      default:
        return <FaTasks className="mr-2" />;
    }
  };






  // const [accesGroupe, setAccesGroupe] = useState([]);
  // const [groupeId, setGroupeId] = useState(null);
  // const groupe = localStorage.getItem('groupe');

  // const verifGroupe = async () => {
  //   const groupeStored = localStorage.getItem('groupe');
  //   const accesGroupeStored = localStorage.getItem('accesGroupe');

  //   if (groupeStored && accesGroupeStored) {
  //     setGroupeId(groupeStored);
  //     setAccesGroupe(JSON.parse(accesGroupeStored));
  //   } else {
  //     try {
  //       const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
  //       if (response.status === 200) {
  //         const data = response.data;
  //         setGroupeId(data.groupe);

  //         let cleanedAccessArray = [];
  //         if (Array.isArray(data.acces)) {
  //           cleanedAccessArray = data.acces.map((item) =>
  //             item.acces
  //               ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
  //               : []
  //           ).flat();

  //           setAccesGroupe(cleanedAccessArray);
  //         }

  //         localStorage.setItem('groupe', data.groupe);
  //         localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
  //       }
  //     } catch (error) {
  //       // console.error('Erreur lors de la vérification du groupe', error);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   if (user_id) {
  //     verifGroupe();
  //   }
  // }, [user_id]);

  // if (!accesGroupe.includes("Apprentisage")) {
  //   return null;
  // }

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} titre={titre} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-12">
            <h2 className="d-flex align-items-center">
              <FaChartLine size={25} className="mr-2" />
              Parcours d'Apprentissage
            </h2>
            <small>Aperçu du Parcours.</small>

            <small id="hbreadcrumb" className="d-flex justify-content-end">
              <ol className="breadcrumb custom-breadcrumb">
                <li className="breadcrumb-item custom-breadcrumb-item">
                  <Link to={`/parcours`}>Parcours</Link>
                </li>
              </ol>
            </small>
          </div>
        </div>


        {alert.message && (
          <div className={`alert alert-${alert.type}`}>
            {alert.message}
          </div>
        )}
        <div className="mt-4">

          <div className="row wrapper wrapper-content animated fadeInRight">
            <div className="col-lg-12">
              {!isLoadingGlobale ? (
                <div className="mb-5 mt-0">
                  {Object.keys(groupedParcours).length > 0 ? (
                    Object.keys(groupedParcours).length === 1 ? (
                      <div className="ibox-content col-md-12">
                        {Object.keys(groupedParcours).map((parcoursId) => {
                          const parcoursTitre = groupedParcours[parcoursId][0].parcours_titre;
                          const currentPageData = getCurrentPageData(parcoursId);
                          const filteredPageData = filteredData(parcoursId);
                          const totalItems = filteredPageData.length;
                          const totalPages = Math.ceil(totalItems / itemsPerPage);
                          const parcoursEtapes = groupedParcours[parcoursId];
                          const completedSteps = parcoursEtapes.filter((etape) => etape.statut_etape === "Terminée").length;
                          const totalSteps = parcoursEtapes.length;
                          const progress = Math.round((completedSteps / totalSteps) * 100);

                          return (
                            <React.Fragment key={parcoursId}>
                              {/* ✅ Cartes de statistiques en haut à droite */}
                              <div className="d-flex justify-content-end mb-3">
                                <ParcoursStatsCards etapes={parcoursEtapes} />
                              </div>

                              <div className="d-flex justify-content-between">
                                <div className="d-flex align-items-center justify-content-between flex-wrap">
                                  <div className="d-flex align-items-center mb-2 mb-md-0 flex-wrap" style={{ gap: '14px' }}>
                                    <h5 className="text-dark mr-3 mb-0">{parcoursTitre}</h5>

                                    <div className="d-flex align-items-center">
                                      <h1 className="no-margins mr-2">{completedSteps} / {totalSteps}</h1>
                                      <p className="mb-0">Etapes</p>
                                    </div>

                                    {parcoursListe && parcoursListe.length > 0 && (
                                      (() => {
                                        const parcours = parcoursListe.find(p => p.id === Number(parcoursId));
                                        if (parcours && parcours.ressource != null) {
                                          return (
                                            <button
                                              onClick={() => handleDownloadRessource(parcoursId)}
                                              className="btn btn-success btn-sm ml-2"
                                            >
                                              Ressources <FaFileDownload size={14} />
                                            </button>
                                          );
                                        }
                                        return null;
                                      })()
                                    )}
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Rechercher..."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                  />
                                </div>
                              </div>
                              <div className="custom-table-container">
                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                  <thead>
                                    <tr className="text-center">
                                      <th className="text-secondary text-wrap d-none d-md-table-cell text-left">#</th>
                                      <th className="text-secondary text-wrap d-none d-md-table-cell text-left" onClick={() => handleSort('titre')}>Tâches {sortConfig.key === 'titre'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                      <th className="text-secondary text-wrap d-none d-md-table-cell text-left" onClick={() => handleSort('module')}>Description {sortConfig.key === 'module'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                      <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('date_echeance')}>Échéance {sortConfig.key === 'date_echeance'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                      <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('score')}>Score {sortConfig.key === 'score'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                      <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('statut_etape')}>Avancement {sortConfig.key === 'statut_etape'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                      <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('nbre_heure')}>Action {sortConfig.key === 'titre'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filteredPageData.map((etape, index) => {
                                      const isFirstStep = (index === 0) ||
                                        etape.module === "Ressources" ||
                                        (etape.module === "Cours" && etape.statut_etape === "Terminée");

                                      // Vérifier si l'étape précédente est terminée en utilisant toutes les données
                                      const isPreviousCompleted = isPreviousStepCompleted(etape, filteredPageData);

                                      // Désactiver l'étape si elle n'est pas première ET que l'étape précédente n'est pas terminée
                                      const isDisabled = !isFirstStep && !isPreviousCompleted;

                                      const dateEcheance = new Date(etape.date_echeance.split('/').reverse().join('-'));
                                      const now = new Date();
                                      const isEcheanceDepassee = dateEcheance < now;

                                      return (
                                        <tr key={etape.id}
                                          className="text-center"
                                          style={{
                                            backgroundColor: etape.code_couleur || 'transparent',
                                            color: getTextColor(etape.code_couleur),
                                            opacity: isDisabled ? 0.5 : 1
                                          }}
                                        >
                                          <td className="text-left">{etape.numero}</td>
                                          <td className="text-left d-flex align-items-center">
                                            {getModuleIcon(etape.module)}
                                            {etape.titre}
                                          </td>

                                          <td className="d-none d-md-table-cell">{getModuleName(etape.module)}</td>
                                          <td>
                                            {(() => {
                                              const dateEcheance = new Date(etape.date_echeance.split('/').reverse().join('-'));
                                              const now = new Date();
                                              const isEcheanceDepassee = dateEcheance < now;
                                              const pasTerminee = etape.statut_etape !== "Terminée";

                                              if (pasTerminee) {
                                                // Si pas terminée, on colore selon échéance
                                                return isEcheanceDepassee
                                                  ? <span className="badge badge-danger">{etape.date_echeance}</span>
                                                  : <span>{etape.date_echeance}</span>;
                                              } else {
                                                // Si terminée, on affiche sans badge, couleur neutre
                                                return <span>{etape.date_echeance}</span>;
                                              }
                                            })()}
                                          </td>
                                          <td className="d-none d-md-table-cell">
                                            {etape.score
                                              ? `${etape.score} (${etape.pourcentage_evaluation}%)`
                                              : ''}
                                          </td>
                                          <td className="d-none d-md-table-cell">
                                            <span className="badge badge-primary">
                                              {etape.statut_etape === "Terminée" && <FaCheck />}
                                            </span>
                                          </td>
                                          <td>
                                            {((etape.module === "Evaluation" || etape.module === "Revision" || etape.module === "Eligibilite" || etape.module === "Avis_client") &&
                                              (etape.module !== "Revision" || etape.statut_etape !== "Terminée")) ||
                                              (etape.module === "Cours" && etape.fichier && etape.statut_etape === "Terminée") ||
                                              (etape.module === "Ressources" && etape.fichier) ||
                                              etape.score ||
                                              etape.lien_url ? (
                                              <Dropdown>
                                                <Dropdown.Toggle variant="light" id="dropdown-basic" className="p-0 pr-1 pl-1">
                                                  <i className="fa fa-ellipsis-v text-dark"></i>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className="p-1">
                                                  {/* Option pour Eligibilite */}
                                                  {etape.module === "Eligibilite" && (
                                                    <Dropdown.Item
                                                      onClick={() => handleEtapeClick(etape)}
                                                      disabled={isDisabled}
                                                      className="d-flex align-items-center"
                                                    >
                                                      <i className="fa fa-flag-checkered mr-2" />
                                                      Terminer
                                                    </Dropdown.Item>
                                                  )}

                                                  {/* Options pour Evaluation et Revision */}
                                                  {(etape.module === "Evaluation" || etape.module === "Revision") &&
                                                    (etape.module !== "Revision" || etape.statut_etape !== "Terminée") && (
                                                      <Dropdown.Item
                                                        onClick={() => handleEtapeClick(etape)}
                                                        disabled={isDisabled}
                                                        className="d-flex align-items-center"
                                                      >
                                                        {etape.module === "Revision" ? (
                                                          <>
                                                            <i className="fa fa-flag-checkered mr-2" />
                                                            Terminer
                                                          </>
                                                        ) : etape.statut_etape === "Terminée" ? (
                                                          <>
                                                            <i className="fa fa-undo mr-2" />
                                                            Reprendre
                                                          </>
                                                        ) : (
                                                          <>
                                                            <i className="fa fa-question-circle mr-2" />
                                                            Lancer qcm
                                                          </>
                                                        )}
                                                      </Dropdown.Item>
                                                    )}

                                                  {/* Autres options (uniquement si ce n'est pas une Eligibilite) */}
                                                  {etape.module !== "Eligibilite" && (
                                                    <>
                                                      {etape.module === "Cours" && etape.fichier && etape.statut_etape === "Terminée" && (
                                                        <Dropdown.Item
                                                          onClick={() => handleDownload(etape.id)}
                                                          className="d-flex align-items-center"
                                                        >
                                                          <i className="fa fa-download mr-2"></i>
                                                          Télécharger
                                                        </Dropdown.Item>
                                                      )}

                                                      {etape.score && (
                                                        <Dropdown.Item
                                                          onClick={() => handleHistorique(etape.id, etape.parcours_id)}
                                                          className="d-flex align-items-center"
                                                        >
                                                          <i className="fa fa-history mr-2"></i>
                                                          Historique
                                                        </Dropdown.Item>
                                                      )}

                                                      {etape.lien_url && (
                                                        <Dropdown.Item
                                                          onClick={() => window.open(etape.lien_url, '_blank')}
                                                          className="d-flex align-items-center"
                                                        >
                                                          <i className="fa fa-play-circle mr-2"></i>
                                                          Voir vidéo
                                                        </Dropdown.Item>
                                                      )}

                                                      {etape.module === "Avis_client" && (
                                                        <Dropdown.Item
                                                          onClick={() => navigate(`/Formulaire-avis-client`, {
                                                            state: { etapeId: etape.id }
                                                          })}
                                                          disabled={isDisabled}
                                                          className="d-flex align-items-center"
                                                        >
                                                          <i className="fa fa-star mr-2" />
                                                          Lancer avis
                                                        </Dropdown.Item>
                                                      )}
                                                    </>
                                                  )}
                                                </Dropdown.Menu>
                                              </Dropdown>
                                            ) : null}
                                          </td>
                                        </tr>
                                      );
                                    })}

                                  </tbody>
                                </table>
                              </div>

                              {/* Pagination Controls */}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    ) : (
                      // Affichage des deux tableaux si plusieurs parcours
                      <div className="d-flex flex-column flex-md-row">
                        {/* Section gauche : Tableau des parcours */}
                        <div className="ibox-content col-md-3 order-1 order-md-1 mr-md-2">
                          <table
                            className="footable table table-stripped footable-loaded tablet breakpoint"
                            data-page-size="8"
                            data-filter="#filter"
                          >
                            <thead>
                              <tr className="d-flex justify-content-between">
                                <th>Parcours</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.keys(groupedParcours)
                                .sort((a, b) => b - a)
                                .map((parcoursId, index) => {
                                  // const isDefaultOpen = index === 0;
                                  const parcoursTitre = groupedParcours[parcoursId][0].parcours_titre;



                                  return (
                                    <React.Fragment key={parcoursId}>
                                      <tr
                                        className={`cursor-pointer ${openParcoursId === parcoursId
                                          ? 'text-white bg-success'
                                          : 'text-dark'
                                          }`}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleToggle(parcoursId)}
                                      >
                                        <td className="d-flex justify-content-between">
                                          {parcoursTitre}
                                          {openParcoursId === parcoursId && (
                                            <FaChevronRight className="ml-2" />
                                          )}
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>

                        {/* Section droite : Détails */}
                        <div className="ibox-content col-md-9 order-2 order-md-2">
                          {Object.keys(groupedParcours).length > 0 ? (
                            <div>
                              {Object.keys(groupedParcours).map((parcoursId) => {
                                const parcoursTitre = groupedParcours[parcoursId][0].parcours_titre;
                                const currentPageData = getCurrentPageData(parcoursId);
                                const filteredPageData = filteredData(parcoursId);
                                const totalItems = filteredPageData.length;
                                const totalPages = Math.ceil(totalItems / itemsPerPage);
                                const parcoursEtapes = groupedParcours[parcoursId];
                                const completedSteps = parcoursEtapes.filter(
                                  (etape) => etape.statut_etape === 'Terminée'
                                ).length;
                                const totalSteps = parcoursEtapes.length;

                                return (
                                  <React.Fragment key={parcoursId}>
                                    {openParcoursId === parcoursId && (
                                      <div>
                                        {/* ✅ Cartes de statistiques EN HAUT DU BLOC DE DROITE, avant titre et recherche */}
                                        <div className="d-flex justify-content-start mb-3">
                                          <ParcoursStatsCards etapes={parcoursEtapes} />
                                        </div>

                                        {/* Section de titre et recherche */}
                                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                                          {/* Titre et étapes */}
                                          <div className="d-flex align-items-center mb-2 mb-md-0 flex-wrap" style={{ gap: '14px' }}>

                                            {
                                              parcoursListe && parcoursListe.length > 0 && (
                                                (() => {
                                                  const parcours = parcoursListe.find(p => p.id === Number(parcoursId));
                                                  if (parcours && parcours.ressource != null) {
                                                    return (
                                                      <button onClick={() => handleDownloadRessource(parcoursId)} className="btn btn-success mt-2 mr-2 col-auto p-1">
                                                        Ressources <FaFileDownload />
                                                      </button>
                                                    );
                                                  } else {
                                                    return null;
                                                  }
                                                })()
                                              )
                                            }

                                            <div className="d-flex align-items-center">
                                              <h1 className="no-margins mr-2">
                                                {completedSteps} / {totalSteps}
                                              </h1>
                                              <p className="mt-2 mb-0">Étapes</p>
                                            </div>
                                          </div>
                                          {/* Barre de recherche */}
                                          <div className="w-30">
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Rechercher..."
                                              value={searchTerm}
                                              onChange={handleSearchChange}
                                            />
                                          </div>
                                        </div>

                                        {/* Table des étapes */}
                                        <div className="custom-table-container">
                                          <table
                                            className="footable table table-stripped footable-loaded tablet breakpoint"
                                            data-page-size="8"
                                            data-filter="#filter"
                                          >
                                            <thead>
                                              <tr className="text-center">
                                                <th className="text-secondary text-wrap d-none d-md-table-cell text-left">#</th>
                                                <th className="text-secondary text-wrap d-none d-md-table-cell text-left" onClick={() => handleSort('titre')}>Tâches {sortConfig.key === 'titre'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                                <th className="text-secondary text-wrap d-none d-md-table-cell text-left" onClick={() => handleSort('module')}>Description {sortConfig.key === 'module'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                                <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('date_echeance')}>Échéance {sortConfig.key === 'date_echeance'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                                <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('score')}>Score {sortConfig.key === 'score'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                                <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('statut_etape')}>Avancement {sortConfig.key === 'statut_etape'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                                <th className="text-secondary text-wrap d-none d-md-table-cell" onClick={() => handleSort('nbre_heure')}>Action {sortConfig.key === 'titre'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {filteredPageData.map((etape, index) => {
                                                const isFirstStep = (index === 0) ||
                                                  etape.module === "Ressources" ||
                                                  (etape.module === "Cours" && etape.statut_etape === "Terminée");

                                                const isPreviousCompleted = isPreviousStepCompleted(etape, filteredPageData);
                                                const isDisabled = !isFirstStep && !isPreviousCompleted;
                                                const dateEcheance = new Date(etape.date_echeance.split('/').reverse().join('-'));
                                                const now = new Date();
                                                const isEcheanceDepassee = dateEcheance < now;

                                                return (
                                                  <tr
                                                    key={etape.id}
                                                    className="text-center"
                                                    style={{
                                                      backgroundColor: etape.code_couleur || 'transparent',
                                                      color: getTextColor(etape.code_couleur),
                                                      opacity: isDisabled ? 0.5 : 1
                                                    }}
                                                  >
                                                    <td className="text-left">{etape.numero}</td>
                                                    <td className="text-left d-flex align-items-center">
                                                      {getModuleIcon(etape.module)}
                                                      {etape.titre}
                                                    </td>

                                                    <td className="text-left">{getModuleName(etape.module)}</td>
                                                    <td>
                                                      {(() => {
                                                        const dateEcheance = new Date(etape.date_echeance.split('/').reverse().join('-'));
                                                        const now = new Date();
                                                        const isEcheanceDepassee = dateEcheance < now;
                                                        const pasTerminee = etape.statut_etape !== "Terminée";

                                                        if (pasTerminee) {
                                                          return isEcheanceDepassee
                                                            ? <span className="badge badge-danger">{etape.date_echeance}</span>
                                                            : <span>{etape.date_echeance}</span>;
                                                        } else {
                                                          return <span>{etape.date_echeance}</span>;
                                                        }
                                                      })()}
                                                    </td>

                                                    <td>
                                                      {etape.score
                                                        ? `${etape.score} (${etape.pourcentage_evaluation}%)`
                                                        : ''}
                                                    </td>

                                                    <td>
                                                      <span className="badge badge-primary">
                                                        {etape.statut_etape === "Terminée" && <FaCheck />}
                                                      </span>
                                                    </td>
                                                    <td>
                                                      {((etape.module === "Evaluation" || etape.module === "Revision" || etape.module === "Eligibilite" || etape.module === "Avis_client") &&
                                                        (etape.module !== "Revision" || etape.statut_etape !== "Terminée")) ||
                                                        (etape.module === "Cours" && etape.fichier && etape.statut_etape === "Terminée") ||
                                                        (etape.module === "Ressources" && etape.fichier) ||
                                                        etape.score ||
                                                        etape.lien_url ? (
                                                        <Dropdown>
                                                          <Dropdown.Toggle variant="light" id="dropdown-basic" className="p-0 pr-1 pl-1">
                                                            <i className="fa fa-ellipsis-v text-dark"></i>
                                                          </Dropdown.Toggle>

                                                          <Dropdown.Menu className="p-1">
                                                            {etape.module === "Eligibilite" && (
                                                              <Dropdown.Item
                                                                onClick={() => handleEtapeClick(etape)}
                                                                disabled={isDisabled}
                                                                className="d-flex align-items-center"
                                                              >
                                                                <i className="fa fa-flag-checkered mr-2" />
                                                                Terminer
                                                              </Dropdown.Item>
                                                            )}

                                                            {(etape.module === "Evaluation" || etape.module === "Revision") &&
                                                              (etape.module !== "Revision" || etape.statut_etape !== "Terminée") && (
                                                                <Dropdown.Item
                                                                  onClick={() => handleEtapeClick(etape)}
                                                                  disabled={isDisabled}
                                                                  className="d-flex align-items-center"
                                                                >
                                                                  {etape.module === "Revision" ? (
                                                                    <>
                                                                      <i className="fa fa-flag-checkered mr-2" />
                                                                      Terminer
                                                                    </>
                                                                  ) : etape.statut_etape === "Terminée" ? (
                                                                    <>
                                                                      <i className="fa fa-undo mr-2" />
                                                                      Reprendre
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      <i className="fa fa-question-circle mr-2" />
                                                                      Lancer qcm
                                                                    </>
                                                                  )}
                                                                </Dropdown.Item>
                                                              )}

                                                            {etape.module !== "Eligibilite" && (
                                                              <>
                                                                {etape.module === "Cours" && etape.fichier && etape.statut_etape === "Terminée" && (
                                                                  <Dropdown.Item
                                                                    onClick={() => handleDownload(etape.id)}
                                                                    className="d-flex align-items-center"
                                                                  >
                                                                    <i className="fa fa-download mr-2"></i>
                                                                    Télécharger
                                                                  </Dropdown.Item>
                                                                )}

                                                                {etape.score && (
                                                                  <Dropdown.Item
                                                                    onClick={() => handleHistorique(etape.id, etape.parcours_id)}
                                                                    className="d-flex align-items-center"
                                                                  >
                                                                    <i className="fa fa-history mr-2"></i>
                                                                    Historique
                                                                  </Dropdown.Item>
                                                                )}

                                                                {etape.lien_url && (
                                                                  <Dropdown.Item
                                                                    onClick={() => window.open(etape.lien_url, '_blank')}
                                                                    className="d-flex align-items-center"
                                                                  >
                                                                    <i className="fa fa-play-circle mr-2"></i>
                                                                    Voir vidéo
                                                                  </Dropdown.Item>
                                                                )}

                                                                {etape.module === "Avis_client" && (
                                                                  <Dropdown.Item
                                                                    onClick={() => navigate(`/Formulaire-avis-client`, {
                                                                      state: { etapeId: etape.id }
                                                                    })}
                                                                    disabled={isDisabled}
                                                                    className="d-flex align-items-center"
                                                                  >
                                                                    <i className="fa fa-star mr-2" />
                                                                    Lancer avis
                                                                  </Dropdown.Item>
                                                                )}
                                                              </>
                                                            )}
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      ) : null}
                                                    </td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>

                                          </table>
                                        </div>
                                      </div>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="text-center">
                              <p>Aucun parcours trouvé.</p>
                            </div>
                          )}
                        </div>
                      </div>

                    )
                  ) : (
                    <div className="text-center">
                      <div className="ibox-content p-5" style={{
                        borderRadius: "15px",
                        backgroundColor: "#f8f9fa",
                        border: "2px dashed #dee2e6"
                      }}>
                        <div className="mb-4">
                          <FaChartLine size={80} className="text-muted mb-3" />
                          <h3 className="text-muted mb-3">Aucun parcours disponible</h3>
                          <p className="text-muted mb-4">
                            Vous n'avez actuellement aucun parcours d'apprentissage assigné.
                          </p>
                        </div>

                        <div className="row justify-content-center">
                          <div className="col-md-8">

                            <div className="d-flex justify-content-center gap-3 flex-wrap">
                              <button
                                className="btn btn-primary mr-2"
                                onClick={() => window.location.reload()}
                              >
                                <FaRedo className="mr-2" />
                                Actualiser la page
                              </button>
                              <button
                                className="btn btn-outline-secondary"
                                onClick={() => {
                                  const message = encodeURIComponent("Bonjour, je souhaite obtenir des informations sur les parcours d'apprentissage.");
                                  window.open(`https://wa.me/22958585050?text=${message}`, '_blank');
                                }}
                              >
                                <FaBook className="mr-2" />
                                Contacter le support
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  <div className="spiner-example">
                    <div className="sk-spinner sk-spinner-wave">
                      <div className="sk-rect1 mr-1"></div>
                      <div className="sk-rect2 mr-1"></div>
                      <div className="sk-rect3 mr-1"></div>
                      <div className="sk-rect4 mr-1"></div>
                      <div className="sk-rect5"></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* ✅ Histogramme d'évolution des performances (en bas de page, après les deux colonnes) */}
          {!isLoadingGlobale &&
            Object.keys(groupedParcours).length > 0 &&
            openParcoursId &&
            groupedParcours[openParcoursId] && (
              <div className="row wrapper wrapper-content animated fadeInRight" style={{ marginTop: "-60px" }}>
                <div className="col-lg-12">
                  <div className="ibox">
                    <div className="ibox-title d-flex justify-content-between align-items-center">
                      <h5>
                        <FaChartLine className="mr-2" style={{ color: '#1ab394' }} />
                        Évolution des performances
                      </h5>
                      <div className="custom-control custom-switch">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="evolutionGlobalSwitch"
                          checked={globalView}
                          onChange={(e) => setGlobalView(e.target.checked)}
                        />
                        <label className="custom-control-label" htmlFor="evolutionGlobalSwitch">
                          Tous les parcours
                        </label>
                      </div>
                    </div>
                    <div className="ibox-content">
                      <small className="text-muted d-block mb-3">
                        {globalView
                          ? "QCM traités par semaine, tous parcours confondus"
                          : `QCM traités par semaine pour le parcours « ${groupedParcours[openParcoursId][0]?.parcours_titre} »`}
                      </small>
                      <ParcoursEvolutionChart
                        etapes={groupedParcours[openParcoursId]}
                        evaluations={evaluations}
                        globalView={globalView}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default Parcours;